import React from "react";
import { useNavigate } from "react-router-dom";
import { Triangle, BookOpen } from "lucide-react";
import PageLayout from "../components/PageLayout";
import MenuButton from "../components/MenuButton";
import { useLang } from "../context/LangContext";

const KnowledgePage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useLang();

  const items = [
    {
      icon: Triangle,
      title: t("signs"),
      subtitle: t("signsSub"),
      action: () => navigate("/signs"),
    },
    {
      icon: BookOpen,
      title: t("trafficRules"),
      subtitle: t("pdfBook"),
      action: () =>
        window.open(
          "/files/yol-harakat-qoidalari.pdf",
          "_blank",
          "noopener,noreferrer",
        ),
    },
  ];

  return (
    <PageLayout title={t("catKnowledge")} subtitle={t("catKnowledgeSub")}>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {items.map((item, i) => (
          <MenuButton
            key={i}
            icon={item.icon}
            title={item.title}
            subtitle={item.subtitle}
            onClick={item.action}
          />
        ))}
      </div>
    </PageLayout>
  );
};

export default KnowledgePage;
